export default {"src":"/_next/static/media/kimbley.f2448854.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};